export default "__VITE_ASSET__DcPu34hP__"